import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    positionAdjusted: translate({ id: 'locationEditorField.positionAdjusted' }),
  }))

  return api
}
